import React, { useState } from 'react'
import Classes from './Information.module.css'
import InfoTab from './Comp/InfoTab';
import ServiceTab from './Comp/ServicesTab';
import Membership from './Comp/Subscriptions/Membership/Membership';

export default function Information() {
    const [activeTab, setactiveTab] = useState(1);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3 className={Classes.title3} >Company Information</h3>
                    <h5 className={Classes.text} >Manage your company information.</h5>
                </div>
            </div>

            <div className={Classes.navigation} >
                <button className={`${Classes.btn1} ${activeTab === 1 ? Classes.activeBtn : ''} `} onClick={() => { setactiveTab(1) }} > <h5>Information</h5> </button>
                <button className={`${Classes.btn2} ${activeTab === 2 ? Classes.activeBtn : ''} `} onClick={() => { setactiveTab(2) }} > <h5>Services</h5> </button>
                <button className={`${Classes.btn3} ${activeTab === 3 ? Classes.activeBtn : ''} `} onClick={() => { setactiveTab(3) }} > <h5>Subscriptions</h5> </button>

            </div>

            <h3 className='mb-20' > {activeTab === 1 ? 'Information' :activeTab === 2 ?'Services': 'Subscriptions'} </h3>

            {activeTab === 1 && <InfoTab />}
            {activeTab === 2 && <ServiceTab />}
            {activeTab === 3 && <Membership />}

        </div>
    )
}
